import { getHeapCDC } from './Analytics/Heap';
import { checkAndSetSubscribeSrcParam } from './CmpQuery';
import {
  SHEER_FIRST_RESPONDER_TYPE,
  SHEER_MILITARY_TYPE,
  SUBSCRIBE_SOURCE_URL_PARAM_NAME,
  EXTERNAL_DEVICE_ID_PARAM_NAME,
} from './Constants';
import { redirectToExternal } from './Path';
import { getDefaultConfig } from './Store';
import { getXid } from 'Api/ProfileApi';

export const PAGE_INTENTION_MILITARY = 'military';
export const PAGE_INTENTION_FIRST_RESPONDER = 'firstResponder';
export const PAGE_INTENTION_UNKNOWN = 'unknown';

export const redirectToFoxoneSubsPath = async ({ path, params: paramsProp }) => {
  const { subsUrl } = getDefaultConfig();
  const params = paramsProp ? new URLSearchParams(paramsProp) : new URLSearchParams();
  const heapCDC = await getHeapCDC();
  if (heapCDC) {
    params.set('_hp5_cdc', heapCDC);
  }

  const currentUrlParams = new URLSearchParams(window.location.search);
  if (currentUrlParams.has(SUBSCRIBE_SOURCE_URL_PARAM_NAME)) {
    params.set(SUBSCRIBE_SOURCE_URL_PARAM_NAME, currentUrlParams.get(SUBSCRIBE_SOURCE_URL_PARAM_NAME));
  } else {
    checkAndSetSubscribeSrcParam(params);
  }

  const { xid } = getXid();
  if (xid) {
    params.set(EXTERNAL_DEVICE_ID_PARAM_NAME, xid);
  }

  redirectToExternal(`${subsUrl}${path}`, params);
};

export const redirectToFoxoneSubscribeFlow = async ({ selectedPlan } = {}) => {
  const urlParams = new URLSearchParams();
  urlParams.set('forceAuth', 'true');
  if (selectedPlan) addFoxoneSubsSelectParam(selectedPlan, urlParams);
  return redirectToFoxoneSubsPath({ path: 'subscribe', params: urlParams });
};

export const redirectToFoxoneVerificationFlow = async ({ pageIntention } = {}) => {
  const urlParams = new URLSearchParams();
  let verificationType;
  switch (pageIntention) {
    case PAGE_INTENTION_MILITARY:
      verificationType = 'military';
      break;
    case PAGE_INTENTION_FIRST_RESPONDER:
      verificationType = 'responder';
      break;
    default:
      verificationType = undefined;
  }
  if (verificationType) {
    urlParams.set('type', verificationType);
  }
  return redirectToFoxoneSubsPath({ path: 'verification/start', params: urlParams });
};

export const getPageIntention = (sheerId, veteransAdv) => {
  const sheerIdProgram = sheerId?.program;
  const isVaUser = veteransAdv && Boolean(veteransAdv.member_id || veteransAdv.hasVerified);
  if (sheerIdProgram === SHEER_MILITARY_TYPE || isVaUser) {
    return PAGE_INTENTION_MILITARY;
  } else if (sheerIdProgram === SHEER_FIRST_RESPONDER_TYPE) {
    return PAGE_INTENTION_FIRST_RESPONDER;
  }
  return PAGE_INTENTION_UNKNOWN;
};

export const canEvaluateFoxoneSubsRedirect = ({
  subscription,
  isAuthenticated = true,
  isEnabled = isFoxOneRedirectEnabled(),
}) => {
  // Short-circuit if not enabled since shouldRedirectToFoxoneSubs would always return false...
  if (!isEnabled) return true;
  return canEvaluateUserUnmigrated({ subscription, isAuthenticated });
};

export const canEvaluateUserUnmigrated = ({
  subscription: { isFetching, isFetchingStatus, isDone, isStatusDone },
  isAuthenticated,
}) => {
  return !isAuthenticated || (isFetching !== true && isFetchingStatus !== true && isDone && isStatusDone);
};

export const shouldRedirectToFoxoneSubs = ({
  subscription,
  isAuthenticated = true,
  isEnabled = isFoxOneRedirectEnabled(),
}) => {
  if (!isAuthenticated || !isEnabled) return false;

  const shouldNotRedirect = isUserUnmigrated({ subscription });
  return !shouldNotRedirect;
};

export const isUserUnmigrated = ({ subscription: { hasSubscription } }) => {
  return hasSubscription;
};

export const addFoxoneSubsSelectParam = (selectedPlan, result) => {
  if (selectedPlan) {
    let unit = '';
    switch (selectedPlan.period) {
      case 'NoOfMonths':
        unit = 'month';
        break;
      case 'NoOfYears':
        unit = 'year';
        break;
    }

    if (unit) {
      result.set('select', 'foxnation,' + selectedPlan.duration + ',' + unit);
    }
  }
};

function isFoxOneRedirectEnabled() {
  const enableFoxOneRedirect = getDefaultConfig('enableFoxOneRedirect');
  return enableFoxOneRedirect;
}
